<div class="notification-container">
  <!-- ========================== LEFT RAIL ========================== -->
  <!--
    Panel stays in the DOM and is collapsed via CSS so its width transition
    runs in sync with the .left-panel-toggle slide animation.
  -->
  <aside class="left-panel" [class.collapsed]="!showLeftPanel">
    <div class="left-panel-header">
      <div class="search-container">
        <i class="fa fa-search search-icon"></i>
        <input type="text"
               class="search-input"
               placeholder="Search processes"
               [(ngModel)]="searchProcessText" />
        @if (searchProcessText) {
<i class="fa fa-times clear-icon"
          
           (click)="clearSearch()"
           role="button"
           tabindex="0"
           (keydown.enter)="clearSearch()"></i>
}
      </div>
      <button class="btn btn-success btn-add" type="button" (click)="addNewProcess()">
        <i class="fa fa-plus"></i> Add
      </button>
    </div>

    <ul class="process-list">
      @if (isProcessListLoading) {
<li class="process-list-li loading">
        <i class="fa fa-spinner fa-pulse"></i> Loading processes…
      </li>
}
      @if (!isProcessListLoading && filteredProcessNames.length === 0) {
<li class="process-list-li empty"
         >
        No processes to view.
      </li>
}
      @for (process of filteredProcessNames; track trackByName(i, process); let i = $index) {
<li class="process-list-li"
         
          [class.active]="selectedProcessName === process"
          (click)="selectProcess(process, i)"
          role="button"
          tabindex="0"
          (keydown.enter)="selectProcess(process, i)">
        <span class="process-name">{{ process }}</span>
        @if (isLoadingProcessDetails && selectedProcessName === process) {
<i class="fa fa-spinner fa-pulse"
          ></i>
}
      </li>
}
    </ul>
  </aside>

  <!-- Collapse / expand handle (legacy "show-hide-menu") -->
  <button class="left-panel-toggle"
          type="button"
          (click)="toggleLeftPanel()"
          [attr.aria-label]="showLeftPanel ? 'Hide process list' : 'Show process list'">
    <i class="fa" [ngClass]="showLeftPanel ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
  </button>

  <!-- ========================== RIGHT CONTENT ========================== -->
  <section class="right-panel" [class.full-width]="!showLeftPanel">

    <!-- Pill tabs (admin/system-settings style) -->
    <ul class="tab tab-pills">
      <li (click)="setActiveTab('process_details')">
        <a [ngClass]="{ activeTab: activeTab === 'process_details', inactiveTab: activeTab !== 'process_details' }">
          Process Details
        </a>
      </li>
      <li (click)="setActiveTab('process_console')">
        <a [ngClass]="{ activeTab: activeTab === 'process_console', inactiveTab: activeTab !== 'process_console' }">
          Process Console
        </a>
      </li>
      <li (click)="setActiveTab('adhoc_request')">
        <a [ngClass]="{ activeTab: activeTab === 'adhoc_request', inactiveTab: activeTab !== 'adhoc_request' }">
          On Demand Notification
        </a>
      </li>
    </ul>
    <hr class="tab-separator" />

    <!-- Empty state when no process is selected and the user is not in the
         middle of creating a new one. -->
    @if (!selectedProcessName && !isAddingNewProcess && activeTab !== 'adhoc_request' && !isProcessListLoading) {
<div
         class="empty-state">
      <i class="fa fa-arrow-left"></i>
      Select a process from the list, or click <b>Add</b> to create a new one.
    </div>
}

    <!-- ============================================================== -->
    <!-- Tab 1 — Process Details                                        -->
    <!-- ============================================================== -->
    <!-- Visibility is driven by `isAddingNewProcess`, not by the value of
         `process_name`. The legacy predicate hid the whole form on the first
         keystroke (because `process_name === ''` became false) — see the
         migration bug "typing process name clears the whole area". -->
    @if (activeTab === 'process_details' && (!!selectedProcessName || isAddingNewProcess)) {
<div class="tab-body">
      <form #processForm="ngForm" novalidate>

        <!-- Process Name -->
        <div class="field-row"
             [class.field-row--stacked]="!selectedProcess.process_id">
          <label class="field-label">Process Name</label>
          <div class="field-content">
            @if (!selectedProcess.process_id) {

              <input type="text"
                     class="form-control input-sm"
                     name="process_name"
                     [(ngModel)]="selectedProcess.process_name"
                     (ngModelChange)="onChangeProcessName()"
                     required />
              <small class="hint">{{ processNameMessage }}</small>
            
} @else {

              <strong class="readonly-text">{{ selectedProcess.process_name }}</strong>
            
}
            
          </div>
        </div>

        <!-- Description -->
        <div class="field-row">
          <label class="field-label">Description</label>
          <div class="field-content">
            <input type="text"
                   class="form-control input-sm"
                   name="description"
                   [(ngModel)]="selectedProcess.description" />
          </div>
        </div>

        <!-- Subject -->
        <div class="field-row">
          <label class="field-label">Subject</label>
          <div class="field-content">
            <input type="text"
                   class="form-control input-sm"
                   name="subject"
                   [(ngModel)]="selectedProcess.subject" />
          </div>
        </div>

        <!-- Role Group (PrimeNG multiselect — mirrors legacy ng-dropdown-multiselect) -->
        <div class="field-row">
          <label class="field-label">Role Group</label>
          <div class="field-content">
            <ap-dropdown class="role-multiselect"
                         name="userTypeKey"
                         [list]="roleDropdownList"
                         [(ngModel)]="selectedRoles"
                         (onSelect)="onRoleSelectionChange($event.selected)"
                         [selectType]="'multiple'"
                         [enableNgContent]="false"
                         [optionName]="'label'"
                         [optionValue]="'id'"
                         [title]="'Select roles'"
                         [inputAriaLabel]="'Role Group'"
                         [hideTitleOnInput]="true"
                         [showSearchbox]="false"
                         [showSelectAll]="true">
            </ap-dropdown>
          </div>
        </div>

        <!-- Status -->
        <div class="field-row">
          <label class="field-label">Status</label>
          <div class="field-content">
            <div class="radio-group">
              <label class="radio-label">
                <input type="radio" name="processStatus" value="A"
                       [checked]="selectedProcess.processStatus === 'A'"
                       (change)="onStatusChange('A')" />
                Activate
              </label>
              <label class="radio-label">
                <input type="radio" name="processStatus" value="N"
                       [checked]="selectedProcess.processStatus === 'N'"
                       (change)="onStatusChange('N')" />
                Deactivate
              </label>
            </div>
          </div>
        </div>

        <!-- Template Required -->
        <div class="field-row">
          <label class="field-label">Template Required?</label>
          <div class="field-content">
            <div class="radio-group">
              <label class="radio-label">
                <input type="radio" name="html_ind" value="Y"
                       [checked]="selectedProcess.html_ind === 'Y'"
                       (change)="onTemplateRequiredChange('Y')" />
                Yes
              </label>
              <label class="radio-label">
                <input type="radio" name="html_ind" value="N"
                       [checked]="selectedProcess.html_ind === 'N'"
                       (change)="onTemplateRequiredChange('N')" />
                No
              </label>
            </div>
          </div>
        </div>

        <!-- Template Body / Preview / Full HTML -->
        @if (selectedProcess.html_ind === 'Y') {
<div class="field-row template-row">
          <label class="field-label">Template</label>
          <div class="field-content template-content">
            <ul class="template-tabs">
              <li (click)="templateViewTab = 'body'"
                  [class.active]="templateViewTab === 'body'">Body</li>
              <li (click)="templateViewTab = 'preview'"
                  [class.active]="templateViewTab === 'preview'">Preview</li>
              <li (click)="templateViewTab = 'full'"
                  [class.active]="templateViewTab === 'full'">Full HTML</li>
            </ul>
            @if (templateViewTab === 'body') {
<textarea
                      class="form-control template-area"
                      [ngModel]="templateBody"
                      (ngModelChange)="onTemplateBodyChange($event)"
                      name="template_body"
                      rows="14"></textarea>
}
            @if (templateViewTab === 'preview') {
<div
                 class="template-preview"
                 [innerHTML]="selectedProcess.template"></div>
}
            @if (templateViewTab === 'full') {
<pre class="template-preview">{{ selectedProcess.template }}</pre>
}
          </div>
        </div>
}

        <!-- Email TO -->
        <div class="field-row field-row--stacked">
          <label class="field-label">Email (To)</label>
          <div class="field-content">
            <div class="lookup-box">
              <input type="text"
                     class="form-control input-sm"
                     name="email_to_input"
                     placeholder="Type first name, last name or email"
                     [ngModel]="emailInputTo"
                     (ngModelChange)="onLookupChange('TO', $event)"
                     (keydown.enter)="addEmail('TO'); $event.preventDefault()" />
              <span class="lookup-icon">
                @if (loadingEmailTo) {
<i class="fa fa-spinner fa-pulse"></i>
}
                @if (!loadingEmailTo) {
<i class="fa fa-search"></i>
}
              </span>
              @if (userSuggestionsTo.length > 0) {
<ul class="lookup-suggestions">
                @for (user of userSuggestionsTo; track $index) {
<li
                    (click)="selectUserSuggestion('TO', user)">
                  {{ user.name }}
                </li>
}
              </ul>
}
            </div>
            <div class="chip-area">
              @for (entry of emailListTo; track trackByEmailAddress(i, entry); let i = $index) {
<span class="chip"
                   >
                <i class="fa fa-user chip-icon"></i>
                <span class="chip-text">{{ entry.emailAddress }}</span>
                <i class="fa fa-times chip-remove"
                   (click)="removeEmail('TO', i)"
                   role="button"
                   tabindex="0"
                   (keydown.enter)="removeEmail('TO', i)"></i>
              </span>
}
            </div>
          </div>
        </div>

        <!-- Email CC -->
        <div class="field-row field-row--stacked">
          <label class="field-label">Email (CC)</label>
          <div class="field-content">
            <div class="lookup-box">
              <input type="text"
                     class="form-control input-sm"
                     name="email_cc_input"
                     placeholder="Type first name, last name or email"
                     [ngModel]="emailInputCc"
                     (ngModelChange)="onLookupChange('CC', $event)"
                     (keydown.enter)="addEmail('CC'); $event.preventDefault()" />
              <span class="lookup-icon">
                @if (loadingEmailCc) {
<i class="fa fa-spinner fa-pulse"></i>
}
                @if (!loadingEmailCc) {
<i class="fa fa-search"></i>
}
              </span>
              @if (userSuggestionsCc.length > 0) {
<ul class="lookup-suggestions">
                @for (user of userSuggestionsCc; track $index) {
<li
                    (click)="selectUserSuggestion('CC', user)">
                  {{ user.name }}
                </li>
}
              </ul>
}
            </div>
            <div class="chip-area">
              @for (entry of emailListCc; track trackByEmailAddress(i, entry); let i = $index) {
<span class="chip"
                   >
                <i class="fa fa-user chip-icon"></i>
                <span class="chip-text">{{ entry.emailAddress }}</span>
                <i class="fa fa-times chip-remove"
                   (click)="removeEmail('CC', i)"
                   role="button"
                   tabindex="0"
                   (keydown.enter)="removeEmail('CC', i)"></i>
              </span>
}
            </div>
          </div>
        </div>

        <!-- Email BCC -->
        <div class="field-row field-row--stacked">
          <label class="field-label">Email (BCC)</label>
          <div class="field-content">
            <div class="lookup-box">
              <input type="text"
                     class="form-control input-sm"
                     name="email_bcc_input"
                     placeholder="Type first name, last name or email"
                     [ngModel]="emailInputBcc"
                     (ngModelChange)="onLookupChange('BCC', $event)"
                     (keydown.enter)="addEmail('BCC'); $event.preventDefault()" />
              <span class="lookup-icon">
                @if (loadingEmailBcc) {
<i class="fa fa-spinner fa-pulse"></i>
}
                @if (!loadingEmailBcc) {
<i class="fa fa-search"></i>
}
              </span>
              @if (userSuggestionsBcc.length > 0) {
<ul class="lookup-suggestions">
                @for (user of userSuggestionsBcc; track $index) {
<li
                    (click)="selectUserSuggestion('BCC', user)">
                  {{ user.name }}
                </li>
}
              </ul>
}
            </div>
            <div class="chip-area">
              @for (entry of emailListBcc; track trackByEmailAddress(i, entry); let i = $index) {
<span class="chip"
                   >
                <i class="fa fa-user chip-icon"></i>
                <span class="chip-text">{{ entry.emailAddress }}</span>
                <i class="fa fa-times chip-remove"
                   (click)="removeEmail('BCC', i)"
                   role="button"
                   tabindex="0"
                   (keydown.enter)="removeEmail('BCC', i)"></i>
              </span>
}
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="form-actions">
          <button class="btn btn-success btn-sm"
                  type="button"
                  (click)="saveProcess()"
                  [disabled]="isProcessSaving">
            @if (isProcessSaving) {
<i class="fa fa-spinner fa-pulse"></i>
}
            Save
          </button>
          <button class="btn btn-info btn-sm"
                  type="button"
                  (click)="resetProcess()"
                  [disabled]="isProcessSaving">
            Reset
          </button>
        </div>
      </form>
    </div>
}

    <!-- ============================================================== -->
    <!-- Tab 2 — Process Console (gizmo grid)                           -->
    <!-- ============================================================== -->
    @if (activeTab === 'process_console' && selectedProcessName) {
<div class="tab-body console-tab">
      <div class="gt-filter-container">
        <div class="gt-filter-item">
          <i class="fa fa-refresh gt-refresh"
             [class.spinning]="consoleLoading"
             title="Refresh data"
             role="button"
             tabindex="0"
             (click)="refreshConsoleGrid()"
             (keydown.enter)="refreshConsoleGrid()"
             (keydown.space)="refreshConsoleGrid(); $event.preventDefault()"></i>
        </div>
        <div class="gt-filter-item console-process-info">
          <span class="filter-label">Process:</span>
          <strong class="filter-value">{{ selectedProcessName }}</strong>
        </div>
      </div>

      <!--
        Loader overlay is positioned over the grid host so the user does not
        see the bare gizmoGrid scaffold (empty .gg-left-col strip + chrome)
        between scaffold injection and the moment data is loaded.
      -->
      <div class="console-grid-host">
        @if (consoleGridConfig; as cfg) {
<div
             adminGrid
             [gridConfig]="cfg"
             (gridCallback)="onConsoleGridCallback($event)"
             (gridDataLoaded)="onConsoleGridDataLoaded($event)"
             (loadingStateChange)="onConsoleGridLoadingChange($event)"
             class="gizmo-grid"
             tabindex="2"></div>
}

        @if (consoleLoading) {
<div class="grid-loader-overlay">
          <i class="fa fa-spinner fa-pulse"></i>
          <span>Loading notifications…</span>
        </div>
}
      </div>
    </div>
}

    <!-- ============================================================== -->
    <!-- Tab 3 — On Demand Notification                                 -->
    <!-- ============================================================== -->
    @if (activeTab === 'adhoc_request') {
<div class="tab-body">
      <form #adhocForm="ngForm" novalidate>

        <div class="field-row">
          <label class="field-label">Process</label>
          <div class="field-content">
            <select class="form-control input-sm"
                    name="process_name"
                    [(ngModel)]="onDemandNotifDetails.process_name"
                    required>
              <option [ngValue]="''" disabled>-- Select Process --</option>
              @for (process of processNames; track trackByName($index, process)) {
<option
                      [ngValue]="process">{{ process }}</option>
}
            </select>
          </div>
        </div>

        <div class="field-row field-row--stacked">
          <label class="field-label">Payload</label>
          <div class="field-content">
            <textarea class="form-control input-sm"
                      rows="6"
                      name="payload"
                      [(ngModel)]="onDemandNotifDetails.payload"
                      (ngModelChange)="updateJsonObject($event)"
                      required></textarea>
            @if (isJsonValid && !isJsonValidOnInit) {
<span class="json-status valid"
                 >Valid JSON</span>
}
            @if (!isJsonValid && !isJsonValidOnInit) {
<span class="json-status invalid"
                 >Invalid JSON</span>
}
          </div>
        </div>

        <div class="field-row">
          <label class="field-label">Subject</label>
          <div class="field-content">
            <input type="text"
                   class="form-control input-sm"
                   name="subject"
                   [(ngModel)]="onDemandNotifDetails.subject"
                   required />
          </div>
        </div>

        <div class="field-row">
          <label class="field-label">Client</label>
          <div class="field-content">
            <select class="form-control input-sm"
                    name="client_key"
                    [(ngModel)]="onDemandNotifDetails.client_key"
                    required>
              @for (client of clientList; track $index) {
<option
                      [ngValue]="client.client_key">{{ client.client_name || client.name }}</option>
}
            </select>
          </div>
        </div>

        <div class="field-row">
          <label class="field-label">Source</label>
          <div class="field-content">
            <input type="text"
                   class="form-control input-sm readonly-input"
                   name="source_name"
                   [(ngModel)]="onDemandNotifDetails.source_name"
                   disabled />
          </div>
        </div>

        <div class="field-row field-row--stacked">
          <label class="field-label">Email (To)</label>
          <div class="field-content">
            <div class="lookup-box">
              <input type="text"
                     class="form-control input-sm"
                     name="adhoc_email_input"
                     placeholder="Type first name, last name or email"
                     [ngModel]="onDemandNotifDetails.email_addr"
                     (ngModelChange)="onLookupChange('TO_NOTIF', $event)"
                     (keydown.enter)="addNotificationEmail(); $event.preventDefault()" />
              <span class="lookup-icon">
                @if (loadingEmailNotif) {
<i class="fa fa-spinner fa-pulse"></i>
}
                @if (!loadingEmailNotif) {
<i class="fa fa-search"></i>
}
              </span>
              @if (userSuggestionsNotif.length > 0) {
<ul class="lookup-suggestions">
                @for (user of userSuggestionsNotif; track $index) {
<li
                    (click)="selectUserSuggestion('TO_NOTIF', user)">
                  {{ user.name }}
                </li>
}
              </ul>
}
            </div>
            <div class="chip-area">
              @for (entry of notificationTo; track trackByEmailAddress(i, entry); let i = $index) {
<span class="chip"
                   >
                <i class="fa fa-user chip-icon"></i>
                <span class="chip-text">{{ entry.emailAddress }}</span>
                <i class="fa fa-times chip-remove"
                   (click)="removeNotificationEmail(i)"
                   role="button"
                   tabindex="0"
                   (keydown.enter)="removeNotificationEmail(i)"></i>
              </span>
}
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn btn-success btn-sm"
                  type="button"
                  (click)="sendNotification()"
                  [disabled]="isSendingNotification">
            @if (isSendingNotification) {
<i class="fa fa-spinner fa-pulse"></i>
}
            Send Notification
          </button>
          <button class="btn btn-info btn-sm"
                  type="button"
                  (click)="resetNotification()"
                  [disabled]="isSendingNotification">
            Clear
          </button>
        </div>
      </form>
    </div>
}
  </section>
</div>
